<template>
  <v-row :justify="justify_row" no-gutters>
    <v-col
        cols="12" md="6" lg="4"
        class="partner__card"
        :class="!partner.cover ? 'uncover': 'cover'"
        v-for="partner in partners"
        :key="partner.name"
        @click="partner.cover = !partner.cover"
    >
      <div
          v-if="partner.cover"
      >
        <v-img
            alt="placeholder_partner"
            max-width="200"
            max-height="180"
            aspect-ratio="1"
            :src="getFileLink(partner.logo.link)"
        />
        <div class="partner__card_text" v-if="$vuetify.display.width >= 1280">
          {{ partner.name }}
        </div>
        <div class="partner__card_category" v-if="partner?.category" @click.stop="$emit('changeCategory', partner.category.id)">
          {{ partner.category.name }}
        </div>
      </div>
      <div v-else>
        <div v-if="partner.discounts" class="partner__card_discount">
          скидка партнера
        </div>
<!--        <div-->
<!--            class="partner__card_cancel"-->
<!--            @click.stop="partner.cover = !partner.cover"-->
<!--        >-->
<!--          <v-icon size="17" class="font-weight-bold">clear</v-icon>-->
<!--        </div>-->
        <div class="partner__card_uncover_name">
          {{ partner.name }}
        </div>
        <div class="partner__card_uncover_text">
          <span v-html="partner.promo_text"></span>
        </div>
        <div
            class="partner__card_detail"
            @click.stop="getDetail(partner)"
        >
          подробнее
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { defineComponent } from 'vue'
import helper from "@/urls/helper"
import names from "@/modules/personal_account/routers/names"

export default defineComponent({
  name: "PartnerCard",
  props: {
    partners: {
      type: Array,
      default: () => []
    },
    justify_row: {
      type: String,
      default: 'start'
    }
  },
  data () {
    return {
    }
  },
  methods: {
    getFileLink (url) {
      return helper.getMendeleevUrlWithParameters(url.basename, url.action, url.params, null)
    },
    getDetail (item) {
      this.$router.push({ name: names.PARTNER.DETAIL, params: { id: item.id } })
    },
  },
  beforeRouteLeave () {
    if (window.scrollY !== 0) {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
})
</script>

<style scoped lang="scss">
.partner__card {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 33.333333% !important;
  max-width: 290px;
  height: 290px;
  margin: 25px;
  border-radius: 5px;
  box-shadow: 1px 1px 10px 0 rgba(52, 52, 124, 0.1);

  &.cover {
    cursor: pointer;
  }

  &.uncover {
    border-bottom: 3px solid #376FFE;
    box-shadow: 1px 1px 10px rgba(52, 52, 124, 0.1);
  }
}

.partner__card_text {
  position: absolute;
  bottom: 34px;
  left: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 290px;
  flex-wrap: wrap;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  padding: 0 10px;
  color: #313743;
}

.partner__card_discount {
  content: "";
  display: inline-flex;
  position: absolute;
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  width: 155px;
  height: 30px;
  background-color: #376FFE;
  border-radius: 5px 0;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
}

.partner__card_cancel {
  content: "";
  display: inline-flex;
  position: absolute;
  right: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  background-color: #376FFE;
  border-radius: 5px;
  cursor: pointer;
}

.partner__card_category {
  content: "";
  display: inline-flex;
  position: absolute;
  right: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  max-width: 220px;
  padding: 0 10px;
  height: 30px;
  background-color: #376FFE;
  border-radius: 0 5px;
  cursor: pointer;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
}

.partner__card_detail {
  content: "";
  display: inline-flex;
  position: absolute;
  right: 0;
  bottom: -3px;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 30px;
  background-color: #376FFE;
  border-radius: 5px 0;
  cursor: pointer;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
}

.partner__card_uncover_name {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #3254B9;
}

.partner__card_uncover_text {
  margin-top: 20px;
  padding: 0 20px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #313743;
}
</style>
